// extracted by mini-css-extract-plugin
export default {"page":"AuthorisedServiceCentre_page__9rMhX"};